export const fmtR = (m, dp) => {
  if (m === null || m === undefined || Number.isNaN(m)) return "—";
  const neg = m < 0 ? "-" : "";
  const a = Math.abs(m);
  if (a >= 1000) return `${neg}R ${(a / 1000).toFixed(dp ?? (a % 1000 ? 2 : 0))}bn`;
  if (a === 0) return "R 0";
  if (a < 1) return `${neg}R ${(a * 1000).toFixed(0)}k`;
  return `${neg}R ${a.toFixed(dp ?? (a % 1 ? 1 : 0))}m`;
};
export const pct = (v, dp = 1) => (v === null || v === undefined ? "n/a" : `${Number(v).toFixed(dp)}%`);
export const ago = (iso) => {
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86400) return `${Math.floor(s / 3600)} h ago`;
  return `${Math.floor(s / 86400)} d ago`;
};

export const STATUS = {
  verified_demo: { label: "Verified for demo", color: "#10B981" },
  publicly_reported: { label: "Publicly reported", color: "#60A5FA" },
  proposed_pending: { label: "Proposed / pending", color: "#F4B842" },
  illustrative: { label: "Illustrative / synthetic", color: "#C084FC" },
  unverified: { label: "Unverified", color: "#F87171" },
};

export const ACCESS = {
  public: { label: "Public", color: "#10B981" },
  registered: { label: "Registered investors", color: "#60A5FA" },
  restricted: { label: "Restricted", color: "#F4B842" },
  confidential: { label: "Confidential", color: "#F87171" },
};

export const READY = (p) => (p >= 70 ? ["Confirmed", "#10B981"] : p >= 55 ? ["In progress", "#0EA5E9"] : p >= 40 ? ["Under review", "#3B82F6"] : p >= 30 ? ["Feasibility", "#F4B842"] : ["Not started", "#64748B"]);
